import { LocaleCode } from "../../typings/lang";

export class TranslationsInputTextController {
    public static $inject: string[] = ["$scope"];

    // binded
    public rows: number;
    public cols: number;
    public noAutoGrow: boolean;
    public model: any;
    public saveStandard: any;
    public saveTranslation: any;
    public disabled: boolean;
    public required: boolean;
    public name: string;
    public translationField: string;
    public field: string;
    public selectedLang: LocaleCode;
    public sourceLang: LocaleCode;
    public patternInputText: boolean;
    public autoFocus: boolean;
    public onStandardKeyUp: Function;
    public onTranslationKeyUp: Function;

    public modelValue: any;
    public patternChar: RegExp;

    constructor($scope) {
        $scope.$watch(
            () => this.selectedLang,
            (current, previous) => {
                if (this.model && (current || current !== previous)) {
                    $scope.modelValue = this.getTranslationField();
                    if (this.selectedLang === this.sourceLang) {
                        $scope.translationDisabled = false;
                    } else {
                        $scope.translationDisabled = !this.model?.[this.translationField]?.[this.selectedLang];
                    }
                }
            }
        );

        // two way data binding workaround
        $scope.$watch(
            () => $scope.modelValue,
            current => {
                if (this.selectedLang === this.sourceLang) {
                    this.model[this.field] = current;
                } else if (this.model?.[this.translationField]?.[this.selectedLang]) {
                    this.model[this.translationField][this.selectedLang] = current;
                }
            }
        );
    }

    public $onInit() {
        if (this.patternInputText) {
            this.patternChar = new RegExp(/^(?!.*@).*$/);
        }
    }

    public save() {
        if (this.selectedLang === this.sourceLang) {
            this.saveStandard();
        } else {
            this.saveTranslation();
        }
    }

    public keyUp() {
        if (this.selectedLang === this.sourceLang) {
            this.onStandardKeyUp?.();
        } else {
            this.onTranslationKeyUp?.();
        }
    }

    public getTranslationField() {
        if (this.selectedLang === this.sourceLang && !this.model?.[this.translationField]?.[this.selectedLang]) {
            return this.model[this.field];
        } else if (this.model?.[this.translationField]?.[this.selectedLang]) {
            return this.model[this.translationField][this.selectedLang];
        }
        return null;
    }
}
